import { render, staticRenderFns } from "./grid-sub-form-item.vue?vue&type=template&id=5a804263&scoped=true&"
import script from "./grid-sub-form-item.vue?vue&type=script&lang=js&"
export * from "./grid-sub-form-item.vue?vue&type=script&lang=js&"
import style0 from "./grid-sub-form-item.vue?vue&type=style&index=0&id=5a804263&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a804263",
  null
  
)

export default component.exports